export const MODULE_TYPE = "wordfill";
export type TYPE = "wordfill";
